import React, { useEffect, useState } from "react";
import axiosInstance from "../../axiosInstance";
import { URL } from "../../api.jsx";
import getPrivilegeList from "../PrivilegeList.jsx";

const Branch = () => {
  const privilegeList = getPrivilegeList();

  /* ===================== LIST STATE ===================== */
  const [branches, setBranches] = useState([]);

  /* ===================== DROPDOWNS ===================== */
  const [companyList, setCompanyList] = useState([]);
  const [branchDropdown, setBranchDropdown] = useState([]);

  /* ===================== FILTER STATE ===================== */
  const [selectedCompany, setSelectedCompany] = useState("");
  const [selectedBranch, setSelectedBranch] = useState("");
  const [searchText, setSearchText] = useState("");

  /* ===================== PAGINATION ===================== */
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  /* ===================== FETCH COMPANY DROPDOWN ===================== */
  const fetchCompanies = async () => {
    try {
      const res = await axiosInstance.get(URL.COMPANY_LIST_BY_CODE);
      setCompanyList(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Company dropdown error:", err);
      setCompanyList([]);
    }
  };

  /* ===================== FETCH BRANCH DROPDOWN ===================== */
  const fetchBranchDropdown = async () => {
    try {
      const res = await axiosInstance.get(URL.COMPANY_BRANCH);
      setBranchDropdown(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Branch dropdown error:", err);
      setBranchDropdown([]);
    }
  };

  /* ===================== FETCH BRANCH LIST ===================== */
  const fetchBranches = async () => {
    try {
      const lsCompanyCode = localStorage.getItem("companyCode");
      const lsBranchCode = localStorage.getItem("branch_code");

      const params = new URLSearchParams();

      // Restrict to logged-in user's company + branch when both exist
      if (lsCompanyCode && lsBranchCode && lsBranchCode !== "null") {
        params.append("companyCode", lsCompanyCode);
        params.append("branchCode", lsBranchCode);
      } else {
        if (selectedCompany) params.append("companyCode", selectedCompany);
        if (selectedBranch) params.append("branchCode", selectedBranch);
      }

      const res = await axiosInstance.get(
        `${URL.GET_ALL_BEANCHES}?${params.toString()}`
      );

      if (res.data?.data && Array.isArray(res.data.data)) {
        setBranches(res.data.data);
        setCurrentPage(1);
      } else {
        setBranches([]);
      }
    } catch (err) {
      console.error("Fetch branches error:", err);
      setBranches([]);
    }
  };

  /* ===================== INIT ===================== */
  useEffect(() => {
    fetchCompanies();
    fetchBranchDropdown();
    fetchBranches();
  }, []);

  /* ===================== FILTERED DATA ===================== */
  const filteredBranches = branches.filter((b) => {
    const companyName =
      companyList.find((c) => c.id === b.companyCode)?.value || "";

    return (
      b.branchName.toLowerCase().includes(searchText.toLowerCase()) ||
      companyName.toLowerCase().includes(searchText.toLowerCase())
    );
  });

  /* ===================== PAGINATION ===================== */
  const totalPages = Math.ceil(filteredBranches.length / rowsPerPage);
  const paginatedBranches = filteredBranches.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  return (
    <div className="container">
      {/* ===================== HEADER ===================== */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Agency List</h3>

        {privilegeList.branchAdd && (
          <button
            className="btn btn-sm btn-success"
            onClick={() => (window.location.href = "#/BranchAddEdit")}
          >
            + Add Agency
          </button>
        )}
      </div>

      {/* ===================== FILTER SECTION ===================== */}
<div className="card p-3 mb-4">
  <div className="row gx-2 gy-2 align-items-end">
    {/* Company */}
    <div className="col-auto">
      <label className="form-label">Company</label>
      <select
        className="form-select form-select-sm"
        value={selectedCompany}
        onChange={(e) => {
          setSelectedCompany(e.target.value);
          setSelectedBranch("");
        }}
      >
        <option value="">All</option>
        {companyList.map((c) => (
          <option key={c.id} value={c.id}>
            {c.value}
          </option>
        ))}
      </select>
    </div>

    {/* Branch – only when company selected */}
    {selectedCompany && (
      <div className="col-auto">
        <label className="form-label">Agency</label>
        <select
          className="form-select form-select-sm"
          value={selectedBranch}
          onChange={(e) => setSelectedBranch(e.target.value)}
        >
          <option value="">All</option>
          {branchDropdown
            .filter(
              (b) => String(b.companyCode) === String(selectedCompany)
            )
            .map((b) => (
              <option key={b.branchCode} value={b.branchCode}>
                {b.branchName}
              </option>
            ))}
        </select>
      </div>
    )}

    {/* Search */}
    <div className="col-auto">
      <label className="form-label">Search</label>
      <input
        className="form-control form-control-sm"
        placeholder="Branch / Company"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
      />
    </div>

    <div className="col-auto">
      <button className="btn btn-sm btn-primary" onClick={fetchBranches}>
        Search
      </button>
    </div>
  </div>
</div>


      {/* ===================== TABLE ===================== */}
      <div className="table-responsive" style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
        <table className="table tablestyle table-sm table-bordered table-hover align-middle">
          <thead className="table-dark">
            <tr>
              <th>S.No.</th>
              <th>Agency Code</th>
              <th>Agency Name</th>
              <th>Company</th>
              <th>Manager</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>Account No.</th>
              <th>IFSC Code</th>
              <th>GST No.</th>
              <th>City</th>
              <th>Status</th>
              <th>Registered Date</th>
              {privilegeList.branchEdit && <th>Action</th>}
            </tr>
          </thead>
          <tbody>
            {paginatedBranches.length > 0 ? (
              paginatedBranches.map((b, i) => {
                const companyName =
                  companyList.find((c) => c.id === b.companyCode)?.value || "-";

                return (
                  <tr key={b.branchCode}>
                    <td>
                      {(currentPage - 1) * rowsPerPage + i + 1}
                    </td>
                    <td>{b.branchCode}</td>
                    <td>{b.branchName}</td>
                    <td>{companyName}</td>
                    <td>{b.branchManagerName}</td>
                    <td>{b.email}</td>
                    <td>{b.mobile}</td>
                    <td>{b.accountNumber}</td>
                    <td>{b.ifscCode}</td>
                    <td>{b.gstNumber}</td>
                    <td>{b.city}</td>
                    <td>
                      <span
                        className={`badge rounded-pill ${
                          b.status === "ACTIVE"
                            ? "bg-success"
                            : "bg-secondary"
                        }`}
                      >
                        {b.status}
                      </span>
                    </td>
                    <td>{b.createdAt ? String(b.createdAt).replace("T", " ").slice(0, 19) : "-"}</td>

                    {privilegeList.branchEdit && (
                      <td>
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={() =>
                            (window.location.href = `#/BranchAddEdit?branchCode=${b.branchCode}&companyCode=${b.companyCode}`)
                          }
                        >
                          Edit
                        </button>
                      </td>
                    )}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="10" className="text-center text-muted">
                  No branches found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* ===================== PAGINATION ===================== */}
      {filteredBranches.length > rowsPerPage && (
        <div className="d-flex justify-content-center mt-3">
          <div className="d-flex align-items-center" style={{ gap: "5px" }}>
            <button
              className="btn btn-sm btn-outline-primary"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
            >
              Prev
            </button>

            {Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i + 1}
                className={`btn btn-sm ${
                  currentPage === i + 1
                    ? "btn-primary"
                    : "btn-outline-primary"
                }`}
                onClick={() => setCurrentPage(i + 1)}
              >
                {i + 1}
              </button>
            ))}

            <button
              className="btn btn-sm btn-outline-primary"
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((p) => p + 1)}
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Branch;